import script from "./departmentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./departmentPage.vue?vue&type=script&setup=true&lang=js"

import "./departmentPage.vue?vue&type=style&index=0&id=d88a32c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d88a32c0"]])

export default __exports__